import { useEffect, useRef, useMemo } from 'react';
import { EMBEDDED_COMMENT_SIDEBAR_INTERACTIONS } from 'collaboration-sidebar/constants/CollaborationSidebarStateProperties';
import createCommentInteractionsState from 'collaboration-sidebar/factories/CommentInteractions';
export default function useEmbeddedCommentsNavigation({
  commentableArea,
  moduleId,
  onUpdateCollaborationSidebarState,
  navigateTo,
  embeddedCommentSidebarInteractions = createCommentInteractionsState()
}) {
  const {
    scrollTo,
    highlightModuleIdFromHover,
    highlightModuleIdFromClick
  } = embeddedCommentSidebarInteractions;
  const highlightModuleIdFromHoverRef = useRef(highlightModuleIdFromHover);
  const highlightRef = useRef(undefined);
  const isHighlightedBySidebar = useMemo(() => moduleId === highlightModuleIdFromHover || moduleId === highlightModuleIdFromClick, [moduleId, highlightModuleIdFromHover, highlightModuleIdFromClick]);
  useEffect(() => {
    if (scrollTo && scrollTo.moduleId && moduleId === scrollTo.moduleId && commentableArea) {
      // setTimeout with 0 and requestAnimationFrame to ensure the page has finished
      // rendering as much as possible before scrolling.
      setTimeout(() => {
        if (commentableArea) {
          window.requestAnimationFrame(() => {
            commentableArea === null || commentableArea === void 0 || commentableArea.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
            });
          });
        }
      }, 0);
      onUpdateCollaborationSidebarState({
        [EMBEDDED_COMMENT_SIDEBAR_INTERACTIONS]: {
          highlightModuleIdFromClick: moduleId,
          highlightModuleIdFromHover
        }
      });
    }
    highlightModuleIdFromHoverRef.current = highlightModuleIdFromHover;
  }, [moduleId, scrollTo, commentableArea, onUpdateCollaborationSidebarState, highlightModuleIdFromHover]);
  useEffect(() => {
    if (!moduleId && scrollTo && scrollTo.location && scrollTo.moduleId) {
      navigateTo(scrollTo.location, scrollTo.moduleId);
    }
  }, [moduleId, scrollTo, navigateTo]);

  // Clean up highlight timeout on unmount
  useEffect(() => {
    if (highlightModuleIdFromClick && !moduleId) {
      highlightRef.current = setTimeout(() => {
        onUpdateCollaborationSidebarState({
          [EMBEDDED_COMMENT_SIDEBAR_INTERACTIONS]: {
            highlightModuleIdFromClick: null,
            highlightModuleIdFromHover: highlightModuleIdFromHoverRef.current
          }
        });
      }, 2000);
    }

    // Clear the timeout when this component unmounts to
    // avoid updates on an unmounted component.
    return () => clearTimeout(highlightRef.current);
  }, [moduleId, highlightModuleIdFromClick, onUpdateCollaborationSidebarState]);
  return {
    isHighlightedBySidebar
  };
}